import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-sec002-card-X',
  templateUrl: './sec002-card-X.component.html'
})

export class Sec002CardXComponent extends GeneralComponent implements OnInit {
  public formulario?: FormGroup;

  constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
    super('Observação', false);
    if (this.isComercial || this.isBasica) {
      this.formulario = this.formBuilder.group({
        Observacao: [null, []],
        criado_por: [null, []]
      });
    } else if (this.isPreBasica) {
      this.formulario = this.formBuilder.group({
        Observacao: [null, []],
        criado_por: [null, [Validators.required]],
        responsavel: [null, [Validators.required]]
      });
    }

  }

  public async ngOnInit(): Promise<void> {
  }

  public changeCollapse(): void {
    this.collapseCard = this.collapseCard ? false : true;
  }

  public hasErrorFormControl(campoFormulario?: AbstractControl): string {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }



}

